import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';

import { PqrTimesFilters } from './filters';
import { PqrTimesList } from './list';

import { LayoutModule } from '../../../layout/modules';
import { PQR_TIMES, PQR_TIMES_NEW } from '../../../../routes/paths';
import ActionButtonGroup from '../../../components/general/buttons/actionButtonGroup';
import { isOnlyViewProfile } from '../../../../shared/types/profiles';
import { PqrTimeFilter } from '../../../../shared/types/paramPqrTimes';

export const PqrTimes = () => {
    const [filters, setFilters] = useState<PqrTimeFilter>();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    return (
        <>
            <LayoutModule
                title="Búsqueda de Estado PQR"
                showTitle
                additionalButtons={
                    <ActionButtonGroup
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: PQR_TIMES_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: PQR_TIMES,
                        }}
                    />
                }
            >
                <PqrTimesFilters onFilter={(filters) => setFilters(filters)} />
            </LayoutModule>
            <PqrTimesList filters={filters} />
        </>
    );
};
